'use client';

import { trackEvent } from '@alltrails/amplitude/utils/track';
import Typography from '@alltrails/core/components/Typography';
import StatusBadge from '@alltrails/denali/components/StatusBadge';
import Expandable from '../../../Expandable';
import { FooterLinksType } from '../../generateFooterLinks';
import styles from './styles.module.scss';

const MobileLink = ({ href, title, amplitudeEventName, childLinks = [] }: FooterLinksType) => (
  <Expandable
    iconColor="--color-text-primary-inverse"
    title={
      <a
        className={styles.titleLink}
        href={href}
        onClick={() => {
          if (amplitudeEventName) {
            trackEvent(amplitudeEventName);
          }
        }}
      >
        <Typography component="h2" mt="0" mb="0" variant="heading300" color="inverse">
          {title}
        </Typography>
      </a>
    }
  >
    <ul>
      {childLinks.map(link => (
        <li key={link.title} className={styles.listItem}>
          <a
            href={link.href}
            onClick={() => {
              if (link.amplitudeEventName) {
                trackEvent(link.amplitudeEventName);
              }
            }}
          >
            {link.title}
          </a>
          {link.badge && <StatusBadge text={link.badge.text} variant={link.badge.variant} treatment={link.badge.treatment} size={link.badge.size} />}
        </li>
      ))}
    </ul>
  </Expandable>
);

export default MobileLink;
